import moment from "moment";
import "moment/locale/pt-br";
import { useCallback, useEffect, useState } from "react";
import { ColumnDescription, SelectRowProps } from "react-bootstrap-table-next";
import { ListarParcelasRecebidasDadosFinanceirosController } from "../../../../Controllers/Cobranca/ParcelasAbertas/ParcelasAbertasController";

import { IDadosFinanceirosRecebidos } from "../../../../Interfaces/Cobranca/ParcelasAbertas/ParcelasAbertas";
import { formatMoneyReais } from "../../../../Tools/FormatTools";
import SpinnerUAU from "../../../Loding/SpinnerUAU";
import Table from "../../../Table";
import filterFactory, {
    dateFilter,
    textFilter,
} from "react-bootstrap-table2-filter";

interface IDadosFinanceirosRecebidosProps {
    ID_CHAVE_ERP: string;
}

const filtroDeTextoTable = textFilter({
    placeholder: "Filtro...",
});

const filtroDeDataTable = dateFilter({
    placeholder: "Selecione uma data...",
    withoutEmptyComparatorOption: true,
    comparatorClassName: "d-none",
    style: { width: "100%" },
});

export default function DadosFinanceirosRecebidos(
    props: IDadosFinanceirosRecebidosProps
) {
    const [loading, setLoading] = useState(false);
    const [lstContasRecebidos, setLstContasRecebidos] = useState<
        Array<IDadosFinanceirosRecebidos>
    >([]);
    const [indicadores, setIndicadores] = useState({
        QTD_PARCELAS: 0,
        PAGO: 0,
        ORIGINAL: 0,
        JUROS: 0,
        MULTA: 0,
        CORRECAO: 0,
        ACRESCIMOS: 0,
        DESCONTO: 0,
    });
    const [lstSelecionados, setlstSelecionados] = useState<
        Array<IDadosFinanceirosRecebidos>
    >([]);

    const lstContasRecebidosFormatado = lstContasRecebidos.map((item) => ({
        ...item,
        Data_Rec: item.Data_Rec ? new Date(item.Data_Rec) : null,
        DataVenci_Rec: item.DataVenci_Rec ? new Date(item.DataVenci_Rec) : null,
    }));

    const updateDadosFinanceiros = useCallback(() => {
        setLoading(true);
        ListarParcelasRecebidasDadosFinanceirosController(props.ID_CHAVE_ERP)
            .then((res) => {
                setLstContasRecebidos(
                    res.LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO
                );
                const RECEBIDOS = {
                    ...res.LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO.reduce(
                        (indicadores, parcela) => ({
                            PAGO: indicadores.PAGO + parcela.VL_RECEBIDA,
                            ORIGINAL:
                                indicadores.ORIGINAL + parcela.ValorConf_Rec,
                            JUROS: indicadores.JUROS + parcela.VlJurosConf_Rec,
                            MULTA: indicadores.MULTA + parcela.VlMultaConf_Rec,
                            CORRECAO:
                                indicadores.CORRECAO +
                                parcela.VlCorrecaoConf_Rec,
                            ACRESCIMOS:
                                indicadores.ACRESCIMOS +
                                parcela.VlAcresConf_Rec,
                            DESCONTO:
                                indicadores.DESCONTO +
                                parcela.VlDescontoConf_Rec,
                        }),
                        {
                            PAGO: 0,
                            ORIGINAL: 0,
                            JUROS: 0,
                            MULTA: 0,
                            CORRECAO: 0,
                            ACRESCIMOS: 0,
                            DESCONTO: 0,
                        }
                    ),
                    QTD_PARCELAS:
                        res.LISTA_PARCELAS_RECEBIDAS_COBRANCA_DTO.length,
                };
                setIndicadores({
                    ...RECEBIDOS,
                });
            })
            .finally(() => {
                setLoading(false);
            });
    }, [props.ID_CHAVE_ERP]);

    useEffect(() => {
        updateDadosFinanceiros();
    }, [updateDadosFinanceiros]);

    const selectRowProp: SelectRowProps<IDadosFinanceirosRecebidos> = {
        mode: "checkbox",
        onSelect: (row, isSelect, rowIndex, e) => {
            row.FL_MARC = isSelect;
            setlstSelecionados((prevSelecionados) => {
                if (isSelect) {
                    return [...(prevSelecionados ?? []), row];
                } else {
                    return (
                        prevSelecionados?.filter(
                            (selec) => selec.FL_MARC !== row.FL_MARC
                        ) || []
                    );
                }
            });
        },
        onSelectAll: (isSelect, rows) => {
            setlstSelecionados(isSelect ? [...rows] : []);
        },
        selected: lstSelecionados.map((selecionados) => {
            return selecionados.ID_CHAVE_PARCELA;
        }),
    };

    let total = {
        parcelaOriginal: 0,
        juros: 0,
        multa: 0,
        total: 0,
        recebido: 0,
        correcao: 0,
    };
    lstSelecionados.forEach((selecionado) => {
        total.parcelaOriginal += selecionado.ValorPrincipalPrice_rec;
        total.juros += selecionado.VlJurosConf_Rec;
        total.multa += selecionado.VlMultaConf_Rec;
        total.recebido += selecionado.VL_RECEBIDA;
        total.correcao += selecionado.VlCorrecaoConf_Rec;
        total.total +=
            selecionado.VlJurosConf_Rec +
            selecionado.VlMultaConf_Rec +
            selecionado.ValorPrincipalPrice_rec;
    });

    return (
        <div>
            {!loading ? (
                <div>
                    <div className="d-flex flex-wrap justify-content-between mb-2 pl-5 pt-5">
                        <h3>Contas Recebidas</h3>
                        <div className="text-right pr-5">
                            {indicadores.QTD_PARCELAS} Parcelas
                        </div>
                    </div>

                    {lstContasRecebidos && (
                        <>
                            <Table
                                columns={columns}
                                data={lstContasRecebidosFormatado}
                                keyField="ID_CHAVE_PARCELA"
                                tableView={{ columns: columnsTableView }}
                                bordered={false}
                                wrapperClasses="y-scroll maxHeight-300 mb-2"
                                noDataIndication={
                                    <div className="text-center text-muted">
                                        Nenhuma parcela recebida
                                    </div>
                                }
                                selectRow={selectRowProp}
                                filter={filterFactory()}
                            />
                            <div className="card card-custom w-auto mb-2 p-2">
                                <div className="d-flex flex-wrap justify-content-around mr-1">
                                    {!!indicadores.PAGO && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Valor Pago.
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.PAGO
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.ORIGINAL && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Valor Original
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.ORIGINAL
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.MULTA && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Multa
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.MULTA
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.JUROS && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Juros
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.JUROS
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.CORRECAO && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Correção
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.CORRECAO
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.ACRESCIMOS && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Acréscimo
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.ACRESCIMOS
                                                )}
                                            </span>
                                        </div>
                                    )}
                                    {!!indicadores.DESCONTO && (
                                        <div className="d-flex flex-column mb-1 align-items-center p-2">
                                            <span className="text-dark-50 flex-root font-weight-bold">
                                                Desconto
                                            </span>
                                            <span className="text-dark flex-root font-weight-bold">
                                                {formatMoneyReais(
                                                    indicadores.DESCONTO
                                                )}
                                            </span>
                                        </div>
                                    )}
                                </div>
                                <div className="d-flex flex-column justify-content-between align-items-center border border-dark">
                                    <div
                                        className="font-weight-bold"
                                        style={{
                                            fontSize: 17,
                                            textAlign: "center",
                                        }}
                                    >
                                        Parcelas Selecionadas
                                    </div>
                                    <div className="d-flex justify-content-between g-2">
                                        {" "}
                                        <span
                                            className=" ml-2"
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Total:{" "}
                                            {formatMoneyReais(total.total)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Recebido:{" "}
                                            {formatMoneyReais(total.recebido)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Multa Total:{" "}
                                            {formatMoneyReais(total.multa)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Juros Total:{" "}
                                            {formatMoneyReais(total.juros)}
                                        </span>
                                        <span
                                            className=""
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Correção Total:{" "}
                                            {formatMoneyReais(total.correcao)}
                                        </span>
                                        <span
                                            className=" mr-2"
                                            style={{
                                                fontSize: 15,
                                                textAlign: "center",
                                            }}
                                        >
                                            Valor Original Total:{" "}
                                            {formatMoneyReais(
                                                total.parcelaOriginal
                                            )}
                                        </span>
                                    </div>
                                </div>
                            </div>
                        </>
                    )}
                </div>
            ) : (
                <SpinnerUAU />
            )}
        </div>
    );
}

const columns: Array<ColumnDescription> = [
    {
        dataField: "ID_CHAVE_PARCELA",
        text: "",
        headerClasses: "d-none",
        formatter: (c, row) => <RowRecebidos {...row} />,
    },
];
const columnsTableView: Array<ColumnDescription> = [
    {
        dataField: "Tipo_Rec",
        text: "Parcela",
        classes: "p-3 ws-nowrap",
        formatter: (c, row) => `${c} - ${row.NumParc_Rec}`,
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c, row) => `${c} - ${row.NumParc_Rec}`
    },
    {
        dataField: "Data_Rec",
        text: "Data de Recebimento",
        formatter: (c) => new Date(c).toLocaleDateString(),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeDataTable,
    },
    {
        dataField: "DataVenci_Rec",
        text: "Data de Vencimento",
        formatter: (c) => new Date(c).toLocaleDateString(),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeDataTable,
    },
    {
        dataField: "VL_RECEBIDA",
        text: "Valor Pago",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "ValorConf_Rec",
        text: "Valor Principal",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "VlMultaConf_Rec",
        text: "Multa",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "VlJurosConf_Rec",
        text: "Juros",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "VlCorrecaoConf_Rec",
        text: "Correção",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "VlAcresConf_Rec",
        text: "Acréssimos",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "VlDescontoConf_Rec",
        text: "Descontos",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
    {
        dataField: "vlrHonorario",
        text: "Honorário",
        formatter: (c) => formatMoneyReais(c),
        classes: "p-3 ws-nowrap",
        align: "center",
        headerAlign: "center",
        filter: filtroDeTextoTable,
        filterValue: (c) => formatMoneyReais(c)
    },
];

function RowRecebidos(parcela: IDadosFinanceirosRecebidos) {
    return (
        <div className="card card-custom w-auto ml-auto wave wave-animate-slow wave-success border-bottom border-1 border-dark">
            <div className="card-body p-3">
                <div className="d-flex align-itens-center justify-content-between mb-1">
                    <h3 className="font-weight-bolder font-size-normal">
                        <span className="text-dark-75">
                            {parcela.Tipo_Rec} - {parcela.NumParc_Rec}
                        </span>
                    </h3>
                </div>
                <div className="d-flex flex-wrap align-itens-center justify-content-between mb-1">
                    <div className="d-flex flex-wrap flex-column">
                        <span className="d-block font-weight-bold">
                            Data Recebimento
                        </span>
                        <span className="label label-light-primary label-inline mr-2 my-1">
                            {moment(parcela.Data_Rec).format("ll")}
                        </span>
                    </div>
                    <div className="d-flex flex-wrap flex-column">
                        <span className="d-block font-weight-bold">
                            Data Vencimento
                        </span>
                        <span className="label label-light-primary label-inline mr-2 my-1">
                            {moment(parcela.DataVenci_Rec).format("ll")}
                        </span>
                    </div>
                </div>
                <div className="d-flex flex-wrap justify-content-around mr-1">
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Pago
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VL_RECEBIDA)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Valor Principal
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.ValorConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Multa
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VlMultaConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Juros
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VlJurosConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Correção
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VlCorrecaoConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Acréscimos
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VlAcresConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Desconto
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.VlDescontoConf_Rec)}
                        </span>
                    </div>
                    <div className="d-flex flex-column mb-1 p-2 align-items-center">
                        <span className="text-dark-50 flex-root font-weight-bold">
                            Honorário
                        </span>
                        <span className="text-dark flex-root font-weight-bold">
                            {formatMoneyReais(parcela.vlrHonorario)
                                ? formatMoneyReais(parcela.vlrHonorario)
                                : "-"}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
